<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BCLezj/tc-custom/9781634864985.jpg?1723405852834" alt="This image is the cover for the book Ravenous"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ravenous
      </h1>
      <p class="bookDescription body article font2">
        <p>Tall, intelligent and handsome, Hatch Lye is works for Ravenous, a company that tests cookbook recipes for publishing houses. At thirty-five, he’s pretty much settled in his ways.<br/><br/>Then unexpectedly, things change for him when he makes an afternoon coffee run. On the street corner, he meets a homeless man named Kevin Balk. They exchange smiles, a simple hello, and Hatch gives the man money. Without thinking through the consequences of his actions, Hatch invites Kevin back to his home for a meal, shower, and much-needed sleep.<br/><br/>What transpires between the two men over shared meals and the next few weeks of autumn? Can their different lives come together as a romance begins, and secrets of Kevin’s mysterious life are revealed?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.W. Clinger
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c3b63b6